import React from "react";
import { useTranslation } from "react-i18next";
import {
  PaginationContainer,
  PageInfo,
  PageButtonsContainer,
  PageButton,
  PageEllipsis,
} from "./Pagination.styles";

export const Pagination = ({ currentPage, total, limit, pageButtons }) => {
  const { t } = useTranslation();

  if (total <= 0) {
    return null;
  }

  return (
    <PaginationContainer>
      <PageInfo>
        {t("pagination.showing", {
          from: (currentPage - 1) * limit + 1,
          to: Math.min(currentPage * limit, total),
          total: total,
        })}
      </PageInfo>
      <PageButtonsContainer>
        {pageButtons.map((button) => {
          if (button.type === "ellipsis") {
            return <PageEllipsis key={button.key}>{button.label}</PageEllipsis>;
          }

          return (
            <PageButton
              key={button.key}
              onClick={button.onClick}
              disabled={button.disabled}
              active={button.active}
            >
              {button.label}
            </PageButton>
          );
        })}
      </PageButtonsContainer>
    </PaginationContainer>
  );
};
